import { useContext } from 'react'

import { ProductListFiltersContext } from './ProductListFiltersProvider'

export const useProductListFiltersProvider = () =>
	useContext(ProductListFiltersContext)
